// extracted by mini-css-extract-plugin
export default {"preview":"preview_preview__gEDL0","previewImg":"preview_previewImg__4B2Zn"};